import { MAX_RETRIES } from 'config/constants'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const useFloatingTrustpilot = (targetId: string) => {
  const router = useRouter()

  useEffect(() => {
    let retries = 0
    let interval: NodeJS.Timeout | null = null
    let initialized = false
    const path = router.asPath.split('?')[0]
    const pathname = router.pathname
    let resizeObserver: ResizeObserver | null = null

    const isAllowedRoute =
      path === '/' ||
      path === '/earn/' ||
      path === '/exchange/' ||
      path.includes('/loans/') ||
      path.includes('/coin/') ||
      pathname === '/guide-landing'

    const getElement = (id: string): HTMLElement | null => {
      return document.getElementById(id)
    }

    const updatePosition = () => {
      if (typeof document === 'undefined' || typeof window === 'undefined') return

      const widget = getElement('floating-trustpilot')
      const container = getElement(targetId)

      if (!widget || !container) return

      const rect = container.getBoundingClientRect()
      widget.style.position = 'absolute'
      widget.style.top = `${rect.top + window.scrollY - 4}px`
      widget.style.left = `${rect.left + window.scrollX}px`
      widget.style.zIndex = '1000'
      widget.style.display = 'block'
      widget.style.pointerEvents = 'auto'
    }

    const init = () => {
      const widget = document.getElementById('floating-trustpilot') as HTMLElement | null
      const container = document.getElementById(targetId) as HTMLElement | null

      if (widget && container) {
        if (!isAllowedRoute) {
          widget.style.display = 'none'
          return
        }

        updatePosition()

        window.addEventListener('resize', updatePosition)
        window.addEventListener('scroll', updatePosition)

        resizeObserver = new ResizeObserver(() => updatePosition())
        resizeObserver.observe(document.body)
        resizeObserver.observe(container)

        initialized = true
        if (interval) clearInterval(interval!)
      } else if (retries >= MAX_RETRIES) {
        if (interval) clearInterval(interval!)
      } else {
        retries++
      }
    }

    interval = setInterval(init, 500)

    return () => {
      if (interval) clearInterval(interval)

      if (initialized) {
        window.removeEventListener('resize', updatePosition)
        window.removeEventListener('scroll', updatePosition)
        resizeObserver?.disconnect()
      }

      const widget = getElement('floating-trustpilot')

      if (widget && !isAllowedRoute) widget.style.display = 'none'
    }
  }, [targetId, router.asPath])
}
